export var UploadErrorCode;
(function(UploadErrorCode) {
    UploadErrorCode[UploadErrorCode["ITEM_COUNT_QUOTA_LIMIT_REACHED"] = 2] = "ITEM_COUNT_QUOTA_LIMIT_REACHED";
})(UploadErrorCode || (UploadErrorCode = {}));

//# sourceMappingURL=types.js.map